import { abbreviateNumber } from "utils/utils";

export const optionsBar = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      grid: {
        display: false,
      },
    },
  },
  plugins: {
    legend: {
      position: "bottom",
      labels: {
        usePointStyle: true,
        pointStyle: "circle",
        padding: 8,
        boxWidth: 20,
        font: {
          size: 14,
          weight: "normal",
          family: "Poppins",
        },
      },
    },
    title: {
      display: true,
      text: "Daily Trip Analytics",
      align: "start",
      font: {
        size: 20,
        weight: 600,
      },
      padding: {
        top: 0,
        bottom: 20,
      },
      color: "#282828",
    },
  },
};

export const optionsDoughnutCab = {
  responsive: true,
  maintainAspectRatio: false,
  cutout: "60%",
  plugins: {
    legend: {
      position: "bottom",
      //TODO: this script needed for doughnut chart onclick
      // onClick: (event, legendItem, legend) => {
      //   console.log(legend.legendItems, legend)
        
      //   const datasets = legend.legendItems.map((dataset, index) => {
      //     return dataset.text;
      //   });
      
      //   const index = datasets.indexOf(legendItem.text);
      //   if (legend.chart.isDatasetVisible(index) === true) {
      //     legend.chart.hide(index);
      //   } else {
      //     legend.chart.show(index);
      //   }
      // },
      labels: {
        usePointStyle: true,
        pointStyle: "circle",
        padding: 20,
        boxWidth: 10,
        boxHeight: 11,
      //TODO: this script needed for doughnut chart onclick
      //   generateLabels: function(chart) {
      //     var data = chart.data;
      //     if (data.labels.length && data.datasets.length) {
      //         return data.labels.map(function(label, i) {
      //             var dataset = data.datasets[0];
      //             var backgroundColor = dataset.backgroundColor[i];
      //             return {
      //                 text: label,
      //                 fillStyle: backgroundColor,
      //                 strokeStyle: backgroundColor,
      //                 hidden: isNaN(dataset.data[i]),
      //                 textDecoration: isNaN(dataset.data[i]) ? 'line-through' : 'none',
      //                 // You can customize font color, size, family, etc. here
      //                 fontColor: backgroundColor,
      //                 fontSize: 14,
      //                 fontStyle: 'bold',
      //             };
      //         });
      //     }
      //     return [];
      // },
        font: {
          size: 14,
          weight: "600",
          family: "Poppins",
        },
      },
      title: {
        padding: 20,
      },
    },
    title: {
      display: true,
      text: "Total Rides",
      align: "start",
      font: {
        size: 20,
        weight: 600,
        family: "Poppins",
      },
      padding: {
        top: 0,
        bottom: 20,
      },
      color: "#282828",
    },
  },
};

export const optionsDoughnutCustomer = {
  responsive: true,
  maintainAspectRatio: false,
  cutout: "60%",
  plugins: {
    legend: {
      position: "bottom",
      labels: {
        usePointStyle: true,
        pointStyle: "circle",
        padding: 8,
        boxWidth: 20,
        font: {
          size: 14,
          weight: "normal",
        },
      },
    },
    title: {
      display: true,
      text: "Vehicle Category",
      align: "start",
      font: {
        size: 20,
        weight: 600,
      },
      padding: {
        top: 0,
        bottom: 20,
      },
      color: "#282828",
    },
  },
};

export const revenueOptionsBar = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      grid: {
        display: false,
      },
    },
  },
  plugins: {
    legend: { display: false },
    title: {
      display: true,
      text: "Revenue Split",
      align: "start",
      font: {
        size: 20,
        weight: 600,
        family: "Poppins",
      },
      padding: {
        top: 0,
        bottom: 20,
      },
      color: "#282828",
    },
  },
};

export const options = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      grid: {
        display: false,
      },
      border: {
        color: "#000000",
      },
      ticks: {
        display: false,
      },
    },
    y: {
      border: {
        color: "#000000",
      },
      ticks: {
        callback(value) {
          return `₹ ${abbreviateNumber(value)}`;
        },
        color: "#000000",
      },
    },
  },
  plugins: {
    zoom: {
      pan: {
        enabled: true,
        mode: 'x'
    },
      zoom: {
        wheel: {
          enabled: true,
        },
        pinch: {
          enabled: true,
        },
        mode: 'x',
      },
    },
    
    transitions: {
      zoom: {
        animation: {
          duration: 100,
          easing: 'easeOutCubic'
        }
      }
    },
    pan: {
      enabled: true,
      mode: 'x',
    },
    legend: {
      position: "bottom",
      onClick: (event, legendItem, legend) => {
        handleLegendsOnclick(event, legendItem, legend)
      },
      labels: {
        usePointStyle: true,
        pointStyle: "circle",
        boxWidth: 10,
        boxHeight: 8,
        padding: 20,
        generateLabels: (chart) => {
          return handleLegendsColor(chart)
        },
        font: {
          size: 14,
          opacity: 1,
          weight: "600",
          family: "Poppins",
        },
      },
    },
    title: {
      display: true,
      text: "Revenue Split",
      align: "start",
      font: {
        size: 20,
        weight: 600,
        family: "Poppins",
      },
      padding: {
        top: 0,
        bottom: 20,
      },
      color: "#282828",
    },
  },
  elements: {
    point: {
      borderWidth: 5,
      radius: 2,
      backgroundColor: "white",
      borderColor: "white",
    },
  },
};

//handle legends pointer onClick
const handleLegendsOnclick = (event, legendItem, legend) => {
  const datasets = legend.legendItems.map((dataset, index) => {
    return dataset.text;
  });

  const index = datasets.indexOf(legendItem.text);
  if (legend.chart.isDatasetVisible(index) === true) {
    legend.chart.hide(index);
  } else {
    legend.chart.show(index);
  }
}

//handle legends font textColor
const handleLegendsColor = (chart) => {
  let visiblity = [];

  for (let i = 0; i < chart?.data?.datasets?.length; i++) {
    if (chart?.isDatasetVisible(i) === false) {
      visiblity.push(true);
    } else {
      visiblity.push(false);
    }
  }
  return chart?.data?.datasets?.length && chart.data.datasets.map((dataset, index) => ({
    text: dataset.label,
    fillStyle: dataset?.backgroundColor,
    strokeStyle: dataset.borderColor,
    //TODO: this key is needed for to change font size color
    fontColor: dataset?.backgroundColor,
    // fontColor: "#666666",
    hidden: visiblity[index],
  }));
}